<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="6">
        <div class="mt-home-single">
          <div class="flex-between">
            <div class="mt-home-single-name">销售额</div>
            <div class="mt-home-single-day border-theme color-theme">今日</div>
          </div>
          <div class="mt-home-single-num">{{headerInfo.toDaySaleMoney}}</div>
          <div class="mt-home-single-bottom flex-between">
            <div class="mt-home-single-txt">昨日数据</div>
            <div class="mt-home-single-data">{{headerInfo.yesterdaySaleMoney}}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="mt-home-single">
          <div class="flex-between">
            <div class="mt-home-single-name">销售额</div>
            <div class="mt-home-single-day border-theme color-theme">本月</div>
          </div>
          <div class="mt-home-single-num">{{headerInfo.monthSaleMoney}}</div>
          <div class="mt-home-single-bottom flex-between">
            <div class="mt-home-single-txt">上月数据</div>
            <div class="mt-home-single-data">{{headerInfo.lastMonthSaleMoney}}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="mt-home-single">
          <div class="flex-between">
            <div class="mt-home-single-name">用户访问量</div>
            <div class="mt-home-single-day border-theme color-theme">今日</div>
          </div>
          <div class="mt-home-single-num">{{headerInfo.toDayUserVisitNumber}}</div>
          <div class="mt-home-single-bottom flex-between">
            <div class="mt-home-single-txt">昨日数据</div>
            <div class="mt-home-single-data">{{headerInfo.yesterdayUserVisitNumber}}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="mt-home-single">
          <div class="flex-between">
            <div class="mt-home-single-name">用户访问量</div>
            <div class="mt-home-single-day border-theme color-theme">本月</div>
          </div>
          <div class="mt-home-single-num">{{headerInfo.monthUserVisitNumber}}</div>
          <div class="mt-home-single-bottom flex-between">
            <div class="mt-home-single-txt">上月数据</div>
            <div class="mt-home-single-data">{{headerInfo.lastMonthUserVisitNumber}}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="mt-home-single">
          <div class="flex-between">
            <div class="mt-home-single-name">订单量</div>
            <div class="mt-home-single-day border-theme color-theme">今日</div>
          </div>
          <div class="mt-home-single-num">{{headerInfo.toDayOrderNumber}}</div>
          <div class="mt-home-single-bottom flex-between">
            <div class="mt-home-single-txt">昨日数据</div>
            <div class="mt-home-single-data">{{headerInfo.yesterdayOrderNumber}}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="mt-home-single">
          <div class="flex-between">
            <div class="mt-home-single-name">订单量</div>
            <div class="mt-home-single-day border-theme color-theme">本月</div>
          </div>
          <div class="mt-home-single-num">{{headerInfo.monthOrderNumber}}</div>
          <div class="mt-home-single-bottom flex-between">
            <div class="mt-home-single-txt">上月数据</div>
            <div class="mt-home-single-data">{{headerInfo.lastMonthOrderNumber}}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="mt-home-single">
          <div class="flex-between">
            <div class="mt-home-single-name">新增用户</div>
            <div class="mt-home-single-day border-theme color-theme">今日</div>
          </div>
          <div class="mt-home-single-num">{{headerInfo.toDayNewUserNumber}}</div>
          <div class="mt-home-single-bottom flex-between">
            <div class="mt-home-single-txt">昨日数据</div>
            <div class="mt-home-single-data">{{headerInfo.yesterdayNewUserNumber}}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="mt-home-single">
          <div class="flex-between">
            <div class="mt-home-single-name">新增用户</div>
            <div class="mt-home-single-day border-theme color-theme">本月</div>
          </div>
          <div class="mt-home-single-num">{{headerInfo.monthNewUserNumber}}</div>
          <div class="mt-home-single-bottom flex-between">
            <div class="mt-home-single-txt">上月数据</div>
            <div class="mt-home-single-data">{{headerInfo.lastMonthNewUserNumber}}</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="mt-home-echarts">
          <div class="mt-home-echarts-title">日订单量折线图</div>
          <div class="mt-home-echarts-box" ref="echartId" id="echartbox">
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { indexHeaderStatistics, indexUserStatistics } from '@/api/index'
import * as echarts from 'echarts'
export default {
  name: 'Home',
  data () {
    return {
      imgServer: this.$imgServer,
      headerInfo: {
        toDaySaleMoney: '',
        yesterdaySaleMoney: '',
        monthSaleMoney: '',
        lastMonthSaleMoney: '',
        toDayOrderNumber: '',
        yesterdayOrderNumber: '',
        monthOrderNumber: '',
        lastMonthOrderNumber: '',
        toDayNewUserNumber: '',
        yesterdayNewUserNumber: '',
        monthNewUserNumber: '',
        lastMonthNewUserNumber: '',
        toDayUserVisitNumber: '',
        yesterdayUserVisitNumber: '',
        monthUserVisitNumber: '',
        lastMonthUserVisitNumber: ''
      },
      userInfo: {

      },
      // 图表
      optionsChart: {
        color: ['#1890FF'],
        // 标题
        title: [
          {
            show: false,
            text: '暂无数据',
            textStyle: {
              color: '#ccc',
              fontSize: 16
            },
            left: 'center',
            top: 'center'
          }
        ],
        legend: {
          orient: 'horizontal',
          data: ['订单量（个）'],
          textStyle: {
            color: '#000'
            // fontSize: 14
          },
          itemGap: 20,
          itemWidth: 10,
          itemHeight: 10
        },
        grid: {
          top: 30, // 距离容器上边界40像素
          bottom: '70px', // 距离容器下边界30像素
          left: 0,
          right: 0,
          containLabel: true
        },
        // 气泡提示
        tooltip: {
          // axis 指的是在轴上显示   item 指的是鼠标在内容(点)上显示（默认）
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#1890FF'
            }
          }
        },
        dataZoom: [
          {
            id: 'dataZoomX',
            type: 'slider',
            endValue: 5,
            xAxisIndex: [0]
          }
        ],
        xAxis: {
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#333'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            interval: 0,
            textStyle: {
              color: '#333'
            }
          },
          data: []
        },
        yAxis: [{
          type: 'value'
        }],
        // 序列
        series: [
          {
            name: '订单量（个）',
            type: 'line',
            stack: 'Total',
            areaStyle: {
              color: 'rgba(24,144,255,0.1)'
            },
            smooth: true, // 设置为曲线图
            // 或者使用 lineStyle 来设置曲线
            lineStyle: {
              type: 'curve' // 使用贝塞尔曲线
            },
            symbol: 'none',
            emphasis: {
              focus: 'series'
            },
            data: []
          }
        ]
      }
    }
  },
  methods: {
    infoFun () {
      let that = this
      indexHeaderStatistics({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.headerInfo = data
        }
      })
      indexUserStatistics({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.optionsChart.xAxis.data = data.xzData
          that.optionsChart.series[0].data = data.yzData;

          that.chartInit()
        }
      })
    },
    // 图表
    chartInit () {
      var that = this
      this.myChart = echarts.init(this.$refs.echartId)
      this.myChart.setOption(that.optionsChart)
    }
  },
  mounted () {
    this.infoFun()
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/Index.vue